import { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../store";
import { applicationDataSelector, setConfirmationMessage,  } from "../store/slices/applicationData";
let resolveCallback;


function useConfirm() {
  const dispatch = useAppDispatch();
  const AppConfirm = async (text): Promise<boolean> => {
    await dispatch(setConfirmationMessage(text));

    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const onConfirm = async () => {
    await dispatch(setConfirmationMessage(null));
    resolveCallback(true);
  };

  const onCancel = async () => {
    await dispatch(setConfirmationMessage(null));
    resolveCallback(false);
  };

  return { AppConfirm, onConfirm, onCancel };
}

export default useConfirm;
